
<h1>Family tree <span>Clean & responsive</span></h1>
<div class="section-agency-benefit bg-gray section-pt section-pb-60">
  <div id="familyTree">
    <div class="generation" id="grandParents">
      <div class="pair">
        <div class="card-m">Grandpa</div>
        <div class="card-f">Grandma</div>
      </div>

      <div class="pair">
        <div class="card-m">Grandpa</div>
        <div class="card-f">Grandma</div>
      </div>
    </div>

    <div class="generation" id="parents">
        <div class="pair">
          <div class="card-m">Daddy</div>
          <div class="card-f">Mommy</div>
        </div>
    </div>

    <div class="generation" id="child">
      <div class="card-m">Child</div>
    </div>
  </div>
</div>
